export const getGeoCodes = (client) => client.rpc('service-code-mapping', '1/2018-06-07/get_geo_codes', {});
export const getAbiCodes = (client) => client.rpc('service-code-mapping', '1/2018-06-07/get_abi_codes', void 0);
export const getErrorCodes = (client) => client.rpcNoAuth('service-code-mapping', '1/2018-06-07/get_error_codes', void 0);
